import React, { useEffect, useState } from "react";
import "./similarProducts.scss";
import { Box, Button, Grid, useMediaQuery } from "@mui/material";

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
// import required modules
import { FreeMode, Pagination } from "swiper/modules";

import productStore from "../../../store/productStore";
import ProductCard from "../../../components/productCard/ProductCard";
import SmallProductCard from "../../../components/smallProductCard/SmallProductCard";
import SmallProductCardSkeleton from "../../../components/smallProductCard/SmallProductCardSkeleton";

const SimilarProducts = ({ categoryID, productID }) => {
  const maxWidth_1160 = useMediaQuery("(max-width:1160px)");
  const maxWidth_960 = useMediaQuery("(max-width:960px)");
  const maxWidth_780 = useMediaQuery("(max-width:780px)");
  const maxWidth_620 = useMediaQuery("(max-width:620px)");
  const maxWidth_450 = useMediaQuery("(max-width:450px)");
  const maxWidth_300 = useMediaQuery("(max-width:300px)");
  const maxWidth_500 = useMediaQuery("(max-width:500px)");

  const [similarProducts, setSimilarProducts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const ProductStore = productStore();

  useEffect(() => {
    if (ProductStore.mProduct) {
      setIsLoading(true);
      const data = [];
      const finalData = [];
      ProductStore.mProduct.filter((item) => {
        item.categoryID === categoryID && data.push(item);
      });

      const categoryData = [...data];

      categoryData.filter((item) => {
        item._id !== productID && finalData.push(item);
      });

      if (finalData.length) {
        setSimilarProducts(finalData);
      } else {
        setSimilarProducts(null);
      }

      setIsLoading(false);
      // setSimilarProducts(data);
      // setSimilarProducts(ProductStore.mProduct);
    }
  }, [categoryID, ProductStore.mProduct, productID]);

  return (
    <div className="similar-products">
      <div className="similar-products-title">Similar Products</div>

      {isLoading ? (
        <Box className="similar-product-container">
          <Swiper
            slidesPerView={
              maxWidth_300
                ? 1
                : maxWidth_450
                  ? 1.5
                  : maxWidth_620
                    ? 2
                    : maxWidth_780
                      ? 3
                      : maxWidth_960
                        ? 4
                        : maxWidth_1160
                          ? 5
                          : 6
            }
            spaceBetween={0}
            className="mySwiper"
          >
            <SwiperSlide>
              <div style={{ padding: "7px" }}>
                <SmallProductCardSkeleton />
              </div>
            </SwiperSlide>
          </Swiper>
        </Box>
      ) : similarProducts ? (
        <Box className="similar-product-container">
          <Swiper
            slidesPerView={
              maxWidth_300
                ? 1
                : maxWidth_450
                  ? 1.5
                  : maxWidth_620
                    ? 2
                    : maxWidth_780
                      ? 3
                      : maxWidth_960
                        ? 4
                        : maxWidth_1160
                          ? 5
                          : 6
            }
            spaceBetween={0}
            className="mySwiper"
          >
            {similarProducts &&
              similarProducts
                .sort(() => Math.random() - 0.5)
                .slice(0, 6)
                .map((item) => (
                  <SwiperSlide key={item._id}>
                    <div style={{ padding: "7px" }}>
                      <SmallProductCard item={item} />
                    </div>
                  </SwiperSlide>
                ))}
          </Swiper>
        </Box>
      ) : (
        <div className="no-similar-product">
          <p>No Similar Product</p>
        </div>
      )}
    </div>
  );
};

export default SimilarProducts;
